import React, { useState } from 'react';
import TheHeader from './TheHeader';
import TheFooter from './TheFooter';
import TheContent from './TheContent';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import TheSidebar from './TheSidebar';
import { isMobile } from 'react-device-detect';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { fetchPagesMetadata } from '../../redux/slices/metadataSlice';
import { localStorageUtils } from '../../utils/storageUtils';
import commonService from '../../services/common.service';
import { useScroll } from '../context/ScrollContext';

const TheLayout: React.FC = (): any => {
  const { pathname } = useLocation();
  const { scrollToTop } = useScroll();
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.metadata);
  const [isUserRoute, setIsUserRoute] = useState<boolean>(false);
  const userState = localStorageUtils.getInitialUserState();
  const [username, setUsername] = useState<string>('');
  const [slug, setSlug] = useState<string>('');

  useEffect(() => {
    if (userState && userState.user) {
      setUsername(userState.user.first_name);
      setSlug(
        commonService().getSlug(
          `${userState.user.first_name} ${userState.user.last_name}`,
          userState.user.attorney_id,
        ),
      );
    }
  }, [userState]);

  useEffect(() => {
    if (loading) {
      dispatch(fetchPagesMetadata());
    }
  }, [dispatch]);

  useEffect(() => {
    if (
      pathname.includes('account-details') ||
      pathname.includes('/profile') ||
      pathname.includes('change-password') ||
      pathname.includes('change-temporary-password') ||
      pathname.includes('login') ||
      pathname.includes('forgot-password') ||
      pathname.includes('reset-password') ||
      pathname.includes('attorney-registration')
    ) {
      setIsUserRoute(true);
    } else {
      setIsUserRoute(false);
    }
  }, [pathname]);

  useEffect(() => {
    scrollToTop();
  }, [pathname, scrollToTop]);

  return (
    <>
      <TheHeader userState={userState} username={username} slug={slug} />
      <Container
        className={`mb-5 ${isUserRoute ? 'p-0' : ''}`}
        fluid={isUserRoute}
      >
        <Row>
          <Col lg={isUserRoute ? 12 : 9} md={12} sm={12}>
            <TheContent />
          </Col>
          {!isMobile && !isUserRoute && (
            <Col lg={3} md={12} sm={12}>
              <TheSidebar />
            </Col>
          )}
        </Row>
      </Container>
      <TheFooter />
    </>
  );
};

export default TheLayout;
